/* biome-ignore-all lint/complexity/noForEach: Dawn 標準コードは挙動維持のため変更しない */
/* biome-ignore-all lint/complexity/noStaticOnlyClass: Dawn 標準コードは挙動維持のため変更しない */
/* biome-ignore-all lint/complexity/noArguments: Dawn 標準コードは挙動維持のため変更しない */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

window.SectionId = SectionId;

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => {
      callback(newContent);
    });

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      if (element.id) {
        element.id = `${element.id}-${uniqueKey}`;
      }
      if (element.form) {
        element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
      }
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => {
      callback(newNode);
    });

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      newScriptTag.async = false;
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

window.HTMLUpdateUtility = HTMLUpdateUtility;

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    // header-drawer/menu-drawer は独自の開閉・aria-expanded 制御を持つため、汎用ハンドラとの二重処理を防ぐ
    if (event.currentTarget.closest('header-drawer, menu-drawer')) return;

    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = () => {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = (event) => {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (_e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (_event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (video.closest('[data-autoplay-persist]')) return;
    video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

window.pauseAllMedia = pauseAllMedia;

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(_event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (
        parseInt(this.input.dataset.min, 10) > parseInt(this.input.step, 10) &&
        this.input.value === '0'
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min, 10);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value, 10);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value, 10) <= parseInt(this.input.min, 10));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max, 10);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return (...args) => {
    const now = Date.now();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/* 他ファイルから参照される共通ヘルパーを明示的に公開する */
window.debounce = debounce;
window.throttle = throttle;
window.fetchConfig = fetchConfig;

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.bind = (fn, scope) =>
  function () {
    return fn.apply(scope, arguments);
  };

Shopify.setSelectorByValue = (selector, value) => {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = (target, eventName, callback) => {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = (path, options) => {
  options = options || {};
  const method = options.method || 'post';
  const params = options.parameters || {};

  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (const key in params) {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options.hideElement || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    const value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    const value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (_e) {
    const selectedOption = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = selectedOption.getAttribute('data-provinces');
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const option = document.createElement('option');
        option.value = provinces[i][0];
        option.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(option);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: (selector) => {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: (selector, values) => {
    for (let i = 0, count = values.length; i < count; i++) {
      const option = document.createElement('option');
      option.value = values[i];
      option.innerHTML = values[i];
      selector.appendChild(option);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.addEventListener('click', this.onSummaryClick.bind(this));
    });
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)',
    ).forEach((button) => {
      button.addEventListener('click', this.onCloseButtonClick.bind(this));
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const isMainDrawerClosing =
      detailsElement === this.mainDetailsToggle &&
      detailsElement.classList.contains('menu-closing');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      /* 閉じアニメーション中の再タップは close ではなく reopen として扱う */
      if (isOpen) event.preventDefault();
      isOpen && !isMainDrawerClosing
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)').matches) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement?.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement?.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  connectedCallback() {
    /* 初期ロード時も見た目と操作可能状態を同期し、閉じたメニューをタブ順から外す */
    this.header = this.header || document.querySelector('.section-header');
    this.bindMenuNavigationLinks();
    const isDrawerOpen =
      this.mainDetailsToggle?.hasAttribute('open') &&
      !this.mainDetailsToggle.classList.contains('menu-closing');

    this.setMenuDrawerInteractive(Boolean(isDrawerOpen));
    this.mainDetailsToggle?.classList.remove('menu-opened');

    if (isDrawerOpen && !this.mainDetailsToggle.classList.contains('menu-opening')) {
      this.mainDetailsToggle.classList.add('menu-opened');
      this.header?.classList.add('menu-open');
      this.lockPageScroll();
      this.updateHeaderBottomPosition();
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
      document.body.classList.add('aureme-menu-open');
      window.addEventListener('resize', this.onResize);
    }

    this.mainDetailsToggle
      ?.querySelector('summary')
      ?.setAttribute('aria-expanded', isDrawerOpen ? 'true' : 'false');
  }

  bindMenuNavigationLinks() {
    this.mainDetailsToggle?.addEventListener('click', this.onMenuNavigationLinkClick);
  }

  isSameTabPageNavigationClick(event, link) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.hasAttribute('download')
    ) {
      return false;
    }

    const target = (link.getAttribute('target') || '').trim().toLowerCase();
    if (target && target !== '_self') return false;

    try {
      const url = new URL(link.href, window.location.href);
      return url.protocol === 'http:' || url.protocol === 'https:';
    } catch (_error) {
      return false;
    }
  }

  onMenuNavigationLinkClick = (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !this.mainDetailsToggle?.contains(link)) return;
    if (!this.isSameTabPageNavigationClick(event, link)) return;

    /* 同一タブ遷移中だけロゴ位置を固定し、通常の閉じアニメーションは維持する */
    this.header = this.header || document.querySelector('.section-header');
    this.header?.classList.add('menu-navigation-loading');
    this.closeMenuDrawer(event, null);
  };

  getMenuDrawerInnerContainer() {
    return this.mainDetailsToggle?.querySelector('.menu-drawer__inner-container') || null;
  }

  setMenuDrawerInteractive(isInteractive) {
    const innerContainer = this.getMenuDrawerInnerContainer();
    if (!innerContainer) return;

    innerContainer.inert = !isInteractive;

    if (isInteractive) {
      innerContainer.removeAttribute('aria-hidden');
      return;
    }

    innerContainer.setAttribute('aria-hidden', 'true');
  }

  getMenuFadeDurationMs() {
    const fadeDuration =
      window
        .getComputedStyle(this.mainDetailsToggle)
        .getPropertyValue('--aureme-menu-fade-duration') || '0ms';
    return HeaderDrawer.parseDurationToMs(fadeDuration);
  }

  static parseDurationToMs(value) {
    const normalizedValue = value.trim();
    if (!normalizedValue) return 0;

    if (normalizedValue.endsWith('ms')) {
      return Number.parseFloat(normalizedValue);
    }

    if (normalizedValue.endsWith('s')) {
      return Number.parseFloat(normalizedValue) * 1000;
    }

    return Number.parseFloat(normalizedValue) || 0;
  }

  clearPendingCloseMenuDrawer() {
    if (!this.pendingCloseMenuDrawerTimer) return;

    window.clearTimeout(this.pendingCloseMenuDrawerTimer);
    this.pendingCloseMenuDrawerTimer = null;
  }

  lockPageScroll() {
    if (this.pageScrollLock) return;

    const scrollY = window.scrollY || window.pageYOffset || 0;
    const bodyStyle = document.body.style;
    this.pageScrollLock = {
      scrollY,
      position: bodyStyle.position,
      top: bodyStyle.top,
      left: bodyStyle.left,
      right: bodyStyle.right,
      width: bodyStyle.width,
      overflow: bodyStyle.overflow,
    };

    /* iOS Safari で body の overflow だけでは背面スクロールが残るため、現在位置ごと固定する */
    bodyStyle.position = 'fixed';
    bodyStyle.top = `-${scrollY}px`;
    bodyStyle.left = '0';
    bodyStyle.right = '0';
    bodyStyle.width = '100%';
    bodyStyle.overflow = 'hidden';
  }

  unlockPageScroll() {
    if (!this.pageScrollLock) return;

    const { scrollY, position, top, left, right, width, overflow } = this.pageScrollLock;
    const bodyStyle = document.body.style;
    bodyStyle.position = position;
    bodyStyle.top = top;
    bodyStyle.left = left;
    bodyStyle.right = right;
    bodyStyle.width = width;
    bodyStyle.overflow = overflow;
    this.pageScrollLock = null;
    window.scrollTo(0, scrollY);
  }

  finalizeCloseMenuDrawer() {
    this.mainDetailsToggle?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.classList.remove('menu-closing', 'menu-opened');
    this.header?.classList.remove('menu-closing');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('aureme-menu-open');
    this.unlockPageScroll();
    const stickyHeader = this.header?.querySelector('sticky-header');

    /* 閉じ切った直後の1フレームだけ固定し、状態クラスの抜け際を安定させる */
    this.clearMenuTransitionLockFrame = window.requestAnimationFrame(() => {
      this.header?.classList.remove('menu-transition-lock', 'menu-navigation-loading');
      stickyHeader?.updateHeaderMetrics?.();
      this.clearMenuTransitionLockFrame = null;
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    if (typeof this.borderOffset !== 'number') {
      this.borderOffset = this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    }

    if (this.clearMenuTransitionLockFrame) {
      window.cancelAnimationFrame(this.clearMenuTransitionLockFrame);
      this.clearMenuTransitionLockFrame = null;
    }

    this.clearPendingCloseMenuDrawer();
    this.setMenuDrawerInteractive(true);

    /* ヘッダー状態とドロワー本体を同時に切り替え、空パネルだけ先に見せない */
    this.mainDetailsToggle.classList.remove('menu-closing', 'menu-opened');
    this.header?.classList.remove('menu-closing', 'menu-navigation-loading');
    this.header.classList.add('menu-open', 'menu-transition-lock');
    this.lockPageScroll();
    this.updateHeaderBottomPosition();
    /* 次フレームで再計算し、メニュー開閉後のレイアウト変化によるドロワー位置ずれを防止 */
    window.requestAnimationFrame(() => this.updateHeaderBottomPosition());

    /* backdrop の表示条件やフォーカストラップは親実装の基盤挙動に揃える */
    super.openMenuDrawer(summaryElement);
    window.addEventListener('resize', this.onResize);
    document.body.classList.add('aureme-menu-open');
  }

  closeMenuDrawer(
    event,
    elementToFocus = this.mainDetailsToggle?.querySelector('summary') || null,
  ) {
    this.header = this.header || document.querySelector('.section-header');
    if (this.mainDetailsToggle.classList.contains('menu-closing')) return;

    const shouldRestoreFocus = event !== undefined;
    const fadeDurationMs = this.getMenuFadeDurationMs();

    this.clearPendingCloseMenuDrawer();

    /* 閉じる時は open を維持したまま closing へ切り替え、フェードアウトを見せる */
    this.mainDetailsToggle.classList.remove('menu-opening', 'menu-opened');
    this.mainDetailsToggle.classList.add('menu-closing');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening', 'menu-closing');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });

    this.header?.classList.remove('menu-open');
    this.header?.classList.add('menu-closing');
    /* フェード中は背面クリックをドロワーで受け止めつつ、内部項目だけ操作不可にする */
    this.setMenuDrawerInteractive(false);
    /* focusout 起点のクローズでは外へ移ったフォーカスを奪い返さず、明示操作時だけ戻す */
    removeTrapFocus(shouldRestoreFocus ? elementToFocus : null);
    window.removeEventListener('resize', this.onResize);

    if (fadeDurationMs <= 0) {
      this.finalizeCloseMenuDrawer();
      return;
    }

    /* transitionend 未発火でも片付け漏れしないよう、終了処理はタイマーで保証する */
    this.pendingCloseMenuDrawerTimer = window.setTimeout(() => {
      this.pendingCloseMenuDrawerTimer = null;
      this.finalizeCloseMenuDrawer();
    }, fadeDurationMs + 20);
  }

  disconnectedCallback() {
    this.clearPendingCloseMenuDrawer();

    if (this.clearMenuTransitionLockFrame) {
      window.cancelAnimationFrame(this.clearMenuTransitionLockFrame);
      this.clearMenuTransitionLockFrame = null;
    }

    if (this.resizeFrame) {
      window.cancelAnimationFrame(this.resizeFrame);
      this.resizeFrame = null;
    }

    window.removeEventListener('resize', this.onResize);
    this.mainDetailsToggle?.removeEventListener('click', this.onMenuNavigationLinkClick);
    this.setMenuDrawerInteractive(false);
    this.mainDetailsToggle?.removeAttribute('open');
    this.mainDetailsToggle?.classList.remove('menu-opening', 'menu-closing', 'menu-opened');
    this.mainDetailsToggle?.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    this.header?.classList.remove(
      'menu-open',
      'menu-closing',
      'menu-transition-lock',
      'menu-navigation-loading',
    );
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove('aureme-menu-open');
    this.unlockPageScroll();
  }

  updateHeaderBottomPosition() {
    if (!this.header) return;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset, 10)}px`,
    );
  }

  onResize = () => {
    if (this.resizeFrame) return;

    /* resize 連打時も 1 フレーム 1 回だけ位置再計算し、レイアウト読み取りを抑える */
    this.resizeFrame = window.requestAnimationFrame(() => {
      this.resizeFrame = null;
      this.updateHeaderBottomPosition();
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    });
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model'))
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
    this.handleIntersection = this.handleIntersection.bind(this);
  }

  static get observedAttributes() {
    return ['data-url'];
  }

  connectedCallback() {
    if (this.intersectionObserver) return;

    const opener = this.getOpener();
    if (!opener) return;

    this.intersectionObserver = new IntersectionObserver(this.handleIntersection);
    this.intersectionObserver.observe(opener);
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
    // modal-dialog が body へ付け替わる過程で再接続されるため、observer を作り直せるよう参照も破棄する
    this.intersectionObserver = null;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== 'data-url' || !this.isConnected || !newValue || oldValue === newValue) return;

    // swatch 変更で対象商品 URL が差し替わったら、既存内容を使い回さず modal 内の一覧を再取得する
    this.loadContent(true);
  }

  getProductUrl() {
    return this.dataset.url?.split('?')[0];
  }

  getOpener() {
    return document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`);
  }

  handleIntersection(entries) {
    if (!entries[0]?.isIntersecting) return;

    this.loadContent();
    this.intersectionObserver?.disconnect();
  }

  loadContent(force = false) {
    const productUrl = this.getProductUrl();
    if (!productUrl) return;
    if (!force && this.loadedUrl === productUrl && this.innerHTML.trim() !== '') return;

    const requestUrl = `${productUrl}?section_id=bulk-quick-order-list`;
    this.pendingUrl = productUrl;

    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.pendingUrl !== productUrl) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('.quick-order-list-container')?.parentNode;
        if (!sourceQty) return;

        this.innerHTML = sourceQty.innerHTML;
        this.loadedUrl = productUrl;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this.pendingUrl === productUrl) {
          this.pendingUrl = null;
        }
      });
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName === 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.loopToFirstOnNext = this.hasAttribute('data-loop-to-first-on-next');
    this.loopToLastOnPrevious = this.hasAttribute('data-loop-to-last-on-previous');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.touchStartClientX = null;
    this.touchStartClientY = null;
    this.touchStartPage = null;
    this.touchStartedInInteractiveMedia = false;
    this.touchStartedFromFirstBoundary = false;
    this.touchStartedFromLastBoundary = false;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((_entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    if (this.loopToFirstOnNext || this.loopToLastOnPrevious) {
      this.slider.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.slider.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
      this.slider.addEventListener('touchcancel', this.resetTouchTracking.bind(this));
    }
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  formatCounterValue(value) {
    const numericValue = Number(value);
    if (!this.hasAttribute('data-zero-pad-counter') || Number.isNaN(numericValue)) {
      return String(value);
    }

    return String(numericValue).padStart(2, '0');
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.formatCounterValue(this.currentPage);
      this.pageTotalElement.textContent = this.formatCounterValue(this.totalPages);
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    this.updateNavigationButtons();
  }

  updateNavigationButtons() {
    if (!this.prevButton || !this.nextButton || !this.sliderItemsToShow?.length) return;

    const shouldLoopPrevious = this.enableSliderLooping || this.loopToLastOnPrevious;
    const shouldLoopNext = this.enableSliderLooping || this.loopToFirstOnNext;

    if (
      !shouldLoopPrevious &&
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      !shouldLoopNext &&
      this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = Number(event.currentTarget.dataset.step || 1);
    const shouldLoopPrevious = this.enableSliderLooping || this.loopToLastOnPrevious;
    const shouldLoopNext = this.enableSliderLooping || this.loopToFirstOnNext;
    const currentPage = this.getCurrentPageFromScroll();
    const isNextLoopReady =
      shouldLoopNext && currentPage >= this.totalPages && this.isPageSettled(this.totalPages);
    const isPreviousLoopReady = shouldLoopPrevious && currentPage <= 1 && this.isPageSettled(1);

    if (event.currentTarget.name === 'next' && isNextLoopReady) {
      this.slideScrollPosition = 0;
      this.setSlidePosition(this.slideScrollPosition);
      return;
    }

    if (event.currentTarget.name === 'previous' && isPreviousLoopReady) {
      this.slideScrollPosition =
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1].offsetLeft;
      this.setSlidePosition(this.slideScrollPosition);
      return;
    }

    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  getCurrentPageFromScroll() {
    if (!this.sliderItemOffset) return 1;
    return Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  }

  getLoopBoundaryTolerance() {
    const referenceWidth = Math.abs(this.sliderItemOffset || this.slider.clientWidth || 0);
    return Math.max(Math.round(referenceWidth * 0.12), 60);
  }

  /* 境界ループは、対象スライド位置へ十分近づいた時だけ成立させる */
  isPageSettled(pageNumber) {
    if (!this.sliderItemsToShow?.length) return false;

    const index = Math.min(Math.max(pageNumber - 1, 0), this.sliderItemsToShow.length - 1);
    const targetSlide = this.sliderItemsToShow[index];
    if (!targetSlide) return false;

    return (
      Math.abs(this.slider.scrollLeft - targetSlide.offsetLeft) <= this.getLoopBoundaryTolerance()
    );
  }

  onTouchStart(event) {
    const touch = event.touches?.[0];
    if (!touch) return;

    /* 動画や 3D モデルなどの操作開始はギャラリーループ対象から外す */
    this.touchStartedInInteractiveMedia = this.isInteractiveMediaGestureTarget(event);
    if (this.touchStartedInInteractiveMedia) return;

    this.touchStartClientX = touch.clientX;
    this.touchStartClientY = touch.clientY;
    /* ループ可否はスワイプ開始時のページを基準に判定する */
    this.touchStartPage = this.getCurrentPageFromScroll();
    /* スクロール途中で丸められたページ番号ではなく、境界へ到達済みかを保持する */
    this.touchStartedFromFirstBoundary = this.isPageSettled(1);
    this.touchStartedFromLastBoundary = this.isPageSettled(this.totalPages);
  }

  onTouchEnd(event) {
    if (this.touchStartedInInteractiveMedia) {
      this.resetTouchTracking();
      return;
    }

    const touch = event.changedTouches?.[0];
    if (!touch || this.touchStartClientX === null || this.touchStartClientY === null) {
      this.resetTouchTracking();
      return;
    }

    const swipeDistanceX = this.touchStartClientX - touch.clientX;
    const swipeDistanceY = this.touchStartClientY - touch.clientY;
    const touchStartPage = this.touchStartPage;
    const touchStartedFromFirstBoundary = this.touchStartedFromFirstBoundary;
    const touchStartedFromLastBoundary = this.touchStartedFromLastBoundary;
    this.resetTouchTracking();

    /* 末尾で左スワイプが継続したときだけ先頭へ戻し、通常の横スクロールとは干渉させない */
    const minimumSwipeDistance = 30;
    if (Math.abs(swipeDistanceX) < minimumSwipeDistance) return;
    /* 縦移動が勝るジェスチャーはページスクロール意図として扱い、ループを発火させない */
    if (Math.abs(swipeDistanceX) <= Math.abs(swipeDistanceY)) return;

    if (swipeDistanceX > 0) {
      this.loopToFirstIfNeeded(touchStartPage, touchStartedFromLastBoundary);
      return;
    }

    this.loopToLastIfNeeded(touchStartPage, touchStartedFromFirstBoundary);
  }

  resetTouchTracking() {
    this.touchStartClientX = null;
    this.touchStartClientY = null;
    this.touchStartPage = null;
    this.touchStartedInInteractiveMedia = false;
    this.touchStartedFromFirstBoundary = false;
    this.touchStartedFromLastBoundary = false;
  }

  isInteractiveMediaGestureTarget(event) {
    const interactiveMediaSelector = 'video, iframe, model-viewer, .shopify-model-viewer-ui';
    const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];

    return eventPath.some(
      (node) => node instanceof Element && node.closest(interactiveMediaSelector),
    );
  }

  loopToFirstIfNeeded(touchStartPage, touchStartedFromLastBoundary) {
    if (!this.loopToFirstOnNext || !this.sliderItemsToShow?.length) {
      return;
    }

    const startedFromLastPage = touchStartPage >= this.totalPages;
    if (!startedFromLastPage || !touchStartedFromLastBoundary) return;

    const isLastPage = this.getCurrentPageFromScroll() >= this.totalPages;
    if (!isLastPage || !this.isPageSettled(this.totalPages)) return;

    this.setSlidePosition(0);
  }

  loopToLastIfNeeded(touchStartPage, touchStartedFromFirstBoundary) {
    if (!this.loopToLastOnPrevious || !this.sliderItemsToShow?.length) {
      return;
    }

    const startedFromFirstPage = touchStartPage <= 1;
    if (!startedFromFirstPage || !touchStartedFromFirstBoundary) return;

    const isFirstPage = this.getCurrentPageFromScroll() <= 1;
    if (!isFirstPage || !this.isPageSettled(1)) return;

    this.setSlidePosition(this.sliderItemsToShow[this.sliderItemsToShow.length - 1].offsetLeft);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;
    this.linkToSlideHandler = this.linkToSlide.bind(this);

    this.refreshSliderControlButtons(true);
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  /*
   * テーマエディタでのセクション再描画により参照切れ・要素差し替えが起こるため、
   * 都度接続状態（isConnected）を確認し、必要な時だけ再取得・再バインドする。
   */
  refreshSliderControlButtons(force = false) {
    if (!this.sliderControlWrapper) return;

    const shouldRefresh =
      force ||
      !Array.isArray(this.sliderControlButtons) ||
      this.sliderControlButtons.length === 0 ||
      this.currentPage > this.sliderControlButtons.length ||
      this.sliderControlButtons.some((button) => !button.isConnected);

    if (!shouldRefresh) return;

    this.sliderControlButtons = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
    );
    this.sliderControlLinksArray = this.sliderControlButtons;

    for (const link of this.sliderControlButtons) {
      if (link.dataset.slideshowBound === 'true') continue;
      link.addEventListener('click', this.linkToSlideHandler);
      link.dataset.slideshowBound = 'true';
    }
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.prevButton.removeAttribute('disabled');
    this.refreshSliderControlButtons();

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(_event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    this.refreshSliderControlButtons();
    const targetIndex = this.sliderControlButtons.indexOf(event.currentTarget);
    if (targetIndex === -1) return;

    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (targetIndex + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('select').forEach((select) => {
      this.updateSelectionMetadata({ target: select });
    });

    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      /* 非先頭 option の初期 selected を外す前に、現在の選択肢を退避して先頭へ巻き戻るのを防ぐ */
      const selectedOption = target.selectedOptions[0];
      const previouslySelectedOption = Array.from(target.options).find((option) =>
        option.getAttribute('selected'),
      );
      if (previouslySelectedOption && previouslySelectedOption !== selectedOption) {
        previouslySelectedOption.removeAttribute('selected');
      }
      selectedOption.setAttribute('selected', 'selected');

      const swatchValue = selectedOption.dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        selectedOption.dataset.optionSwatchFocalPoint || 'unset',
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target
        .closest(`.product-form__input`)
        .querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId,
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' },
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector('slideshow-component') &&
          this.classList.contains('complementary-products')
        ) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener(
      'storefront:signincompleted',
      this.handleStorefrontSignInCompleted.bind(this),
    );
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
    this.queueFlushTimer = null;
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    this.scheduleQueueFlush();
  }

  /* setInterval による常時ポーリングをやめ、必要な時だけ setTimeout で再スケジュールして無駄な起動と送信中の衝突を防ぐ */
  scheduleQueueFlush() {
    if (this.queueFlushTimer) return;

    this.queueFlushTimer = window.setTimeout(() => {
      this.queueFlushTimer = null;

      if (this.queue.length === 0) return;
      if (this.requestStarted) {
        this.scheduleQueueFlush();
        return;
      }

      this.sendRequest([...this.queue]);
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id, 10)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;

    if (!requestStarted && this.queue.length > 0) {
      this.scheduleQueueFlush();
    }
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value, 10);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min),
      );
    } else if (inputValue > parseInt(event.target.max, 10)) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.max_error.replace('[max]', event.target.max),
      );
    } else if (inputValue % parseInt(event.target.step, 10) !== 0) {
      this.setValidity(
        event,
        index,
        window.quickOrderListStrings.step_error.replace('[step]', event.target.step),
      );
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}
